
// import $ from "jquery";
import "slick-carousel";

export function prjPhotoSlick() {
  // console.log("prjPhotoSlick2");
  $(".photo_main_item").css("opacity","1");

  $(".photo_main").slick({
    fade: true,
    arrows: true,
    asNavFor: ".photo_sub",
    prevArrow: '<div class="slick__arrow__prev slick__arrow"><span></span></div>',
    nextArrow: '<div class="slick__arrow__next slick__arrow"><span></span></div>',
    
  });

  $(".photo_sub").slick({
    slidesToShow: 4,
    asNavFor: ".photo_main",
    focusOnSelect: true,
    arrows: false,
    draggable: false,
  });
}

// console.log("fjk.projects.indevidual.slick.js");